// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IP51iqYlrDnM5fx907pn {
    font-size: 32px;
    font-weight: 510;
    line-height: 110%;
    margin-bottom: 16px;
    text-align: center;
    color: rgb(var(--placeholder-primary));
}

/*--------------------zero position--------------------*/

.yGTDNFPVT_2hZxD1SpXY {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    height: 95vh;
    overflow-y: auto;
}

@media (max-width: 590px) {
    .yGTDNFPVT_2hZxD1SpXY {
        margin-top: 20px;
    }
}

@media (max-width: 540px) {
    .yGTDNFPVT_2hZxD1SpXY {
        margin-top: 10px;
    }
}

.pssva7hlbZ7aWw0TojD1 {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
}

.yGTDNFPVT_2hZxD1SpXY > .pssva7hlbZ7aWw0TojD1 > img {
    width: 170px;
    height: 170px;
    margin-bottom: 25px;
}

.SjnGZ0BOPayOLWGniGYw {
    margin-top: auto;
}

.yiwQpd4QAmwMl4nrD9HQ {
    font-size: 16px;
    text-align: center;
    line-height: 125%;
    font-weight: 410;
    margin-bottom: 20px;
}

.ToHlYRE4zhZ4ygk5ee_u {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ToHlYRE4zhZ4ygk5ee_u > p {
    font-size: 14px;
    letter-spacing: -0.07px;
}

.ToHlYRE4zhZ4ygk5ee_u > p > span {
    cursor: pointer;
    text-decoration: underline;
    transition: color 0.3s ease 0s;
}

.ToHlYRE4zhZ4ygk5ee_u:hover > p > span {
    color: #007aff;
}

.a146krIkFeVJsIBQUhNi {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    min-height: 20px;
    max-height: 20px;
    max-width: 20px;
    border: 2px solid rgb(var(--accent-brand));
    border-radius: 5px;
    cursor: pointer;
}

.a146krIkFeVJsIBQUhNi > svg {
    position: relative;
    z-index: 2;
}

.KVCiDjzF0HofUQHVco1A {
    border: none;
    background: #007aff;
}

.k_ZhOfZ4zU_4rSaSUhaz {
    margin-top: 20px;
    width: 100%;
    margin-bottom: 8px;
    transition: background 0.3s ease 0s;
}

.k_ZhOfZ4zU_4rSaSUhaz:hover {
    background: rgba(var(--accent-brand), 0.8);
}

.k_ZhOfZ4zU_4rSaSUhaz:disabled {
    background: rgba(var(--accent-brand), 0.3);
}

.o_6b1aFKyesaGWJA6lhI:disabled {
    background: rgba(var(--accent-brand), 0.3);
}

.FIge6i7RzVvPLoghYnGn {
    font-size: 17px;
    color: #007aff;
    background: transparent;
}

.FIge6i7RzVvPLoghYnGn:hover {
    background: transparent;
}

.o_6b1aFKyesaGWJA6lhI {
    background: rgba(0, 122, 255, 0.10);
    width: 100%;
    color: #007aff;
    font-size: 17px;
    font-weight: 590;
    padding: 14px;
    border-radius: 12px;
    height: auto;
    display: block;
    margin-bottom: 20px;
}

.o_6b1aFKyesaGWJA6lhI:hover {
    background: rgba(0, 122, 255, 0.20);
}

/*--------------------/zero position--------------------*/

/*--------------------first position--------------------*/

.uL_9usY6GJPPOb_LFW8V {
    margin-top: 10px;
}

.V4v_zqCE8weyMW5gJcnf {
    margin-bottom: 20px;
}

.LRRSvRm77y_OPnVM14hK {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-bottom: 10px;
}

.lXV704iirmS26rNcj5LQ {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    min-width: 51px;
    min-height: 51px;
    max-width: 51px;
    max-height: 51px;
    color: rgb(var(--placeholder-tertiary));
    background: rgb(var(--secondary-bg));
}

.LRRSvRm77y_OPnVM14hK:not(:first-child) > div:nth-child(2) {
    width: 100%;
}

.hZLiOXHZy4Lt956MURpC {
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 5px;
}

/*--------------------/first position--------------------*/

/*--------------------second position--------------------*/

.d_0M0iJ_z3Xhb6di8ENA {
    margin-top: 10px;
    padding-bottom: 20px;
}

.UOYwq47m_TbU5ybrICz0 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px 8px;
}

.P0Kd2XZHfW_QrGBhXbt_ {
    width: 100%;
}

.P0Kd2XZHfW_QrGBhXbt_ > button {
    width: 100%;
    padding: 16px 12px;
    border-radius: 16px;
    outline: none;
    border: none;
    font-size: 14px;
    color: rgb(var(--placeholder-primary));
    background-color: rgb(var(--secondary-bg));
    line-height: 128%;
}

.ghqiJJET5i12K250CAzn {
    margin: 20px auto;
}

/*--------------------/second position--------------------*/

/*--------------------third position--------------------*/

.d5U8zFNMEAthyEjfjXzG {
    height: 100vh;
    margin-top: 10px;
}

.noSXa_l11Dq4S2ywDC8j {
    font-size: 18px;
    padding: 16px;
    border-radius: 20px;
    width: 100%;
    outline: none;
    line-height: 133.33%;
    letter-spacing: -0.24px;
    background: rgb(var(--secondary-bg)) !important;
    color: rgb(var(--placeholder-primary)) !important;
    border: none;
    margin-bottom: 10px;
}

.CclL_iHPFBjJsj9q0ycT {
    width: 100%;
}

/*--------------------/third position--------------------*/

.rm58JldqLS6XIMo38XYu {
    color: #1c77ff;
    font-size: 16.5px;
    font-weight: 540;
    letter-spacing: 0.43px;
    padding: 0;
    background: transparent;
    cursor: pointer;
    border: none;
    transition: color 0.3s ease 0s;
    justify-content: flex-end;
}

.rm58JldqLS6XIMo38XYu:first-child {
    justify-content: flex-start;
}

.rm58JldqLS6XIMo38XYu:hover {
    color: #055ada;
    background: transparent;
}

.VQDruPYpJiIGv5KkkHQU {
    font-size: 32px;
    color: rgb(var(--placeholder-primary));
    font-weight: 760;
    letter-spacing: 0.43px;
    text-align: center;
    line-height: 129.41%;
    white-space: nowrap;
    margin-bottom: 24px;
}

@media (max-width: 350px) {
    .VQDruPYpJiIGv5KkkHQU {
        font-size: 25px;
    }
}

.LRRSvRm77y_OPnVM14hK {
    position: relative;
}

.LgUDky7ZZiUuLwfUJyBL > input {
    border: 1px solid rgb(var(--accent-error));
}

.LgUDky7ZZiUuLwfUJyBL > div {
    color: rgb(var(--accent-error)) !important;
}

.KGHvhpclrtreSkfVyQXI > input {
  border: 1px solid rgba(11, 167, 11, 0.6) !important;
}

.KGHvhpclrtreSkfVyQXI > div {
    color: rgba(11, 167, 11, 0.7) !important;
}

.zqqoUqkoaE_Od4_WXkxx {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-102%, -50%);
    /* -102% /  2% */
    width: calc(50% - 8px) ; 
    height: calc(100% - 2px);
    border-radius: 12px;
    background: rgb(var(--accent-brand));
    z-index: 4;
  
  }

.kseZACPkNjHSTJfhwy12 {
    padding: 2px;
    border-radius: 8.91px;
    background: rgb(var(--secondary-bg));
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    position: relative;
  }
  
  .YwrAxcpCmZy6IFiCkfm6 {
    padding: 5px 15px;
    height: auto;
    background: transparent;
    font-size: 14.5px;
    line-height: 138%;
    width: 100%;
    cursor: pointer;
    z-index: 5;
  }
  
  .YwrAxcpCmZy6IFiCkfm6:hover {
    background: transparent;
  }
  
  .jfcQjBAaduc7C3EnPBcQ {
    border-radius: 6.93px;
    border: 0.5px solid rgba(116, 116, 128, 0.08);
    background: rgb(var(--accent-brand));
    font-weight: 510;
    transition: color 0.3s ease 0s;
  }
  
  .jfcQjBAaduc7C3EnPBcQ:hover {
    color: rgba(var(--placeholder-primary), 0.1);
  }
  
  @media (max-width: 350px) {
    .YwrAxcpCmZy6IFiCkfm6 {
      padding: 5px 10px;
    }
    .LO0riiiLHiTZWbUh9aW9 {
      padding: 14px 15px;
      font-size: 17px;
    }
}

  /* choose version */
  
.kZl7u4PdYU6PqWT_9l6D,
.ULi2QXduOyITYa2yywbi {
  width: 100%;
  background: transparent;
  padding: 10px 0;
  justify-content: flex-start;
  font-size: 16px;
  font-weight: 410;
  line-height: 129%;
}

.kZl7u4PdYU6PqWT_9l6D {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  /* transition: all 0.3s ease 0s; */
}

/* .action:hover {
    opacity: 0.8;
} */

.kZl7u4PdYU6PqWT_9l6D:last-child {
  margin-bottom: 10px;
}

.kZl7u4PdYU6PqWT_9l6D:not(:last-child):after {
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  bottom: 0;
  right: 0;
  background: rgba(116, 116, 128, 0.4);
}

.ig31NSKuh0yr69rwHx3w {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 43px;
}

.yjwLtc0pMOnJmh7RQQXV {
    position: relative;
    margin-bottom: 24px;
}

.Tn2JFwS0TZeU1G3zizwQ {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    padding: 8px;
    border-radius: 16px;
    background: rgb(var(--secondary-bg));
    position: relative;
    cursor: pointer;
    transition: background 0.3s ease 0s;
}

.Tn2JFwS0TZeU1G3zizwQ:hover {
    background: rgba(var(--secondary-bg), 0.9);
}

.Tn2JFwS0TZeU1G3zizwQ > button {
    max-width: 40px;
    max-height: 40px;
    min-width: 40px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    border: none;
    background: rgb(var(--tertiary-bg));
    cursor: pointer;
}

._8VDiP0jRAUwdgPvH6E0 {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 60px;
    z-index: 5;
    background: rgb(var(--secondary-bg));
    border-radius: 16px;
    padding: 8px 14px;
}

._8VDiP0jRAUwdgPvH6E0 > div{
    font-size: 14px !important;
}

.MOAOWC11f0BodImCs5gw {
    padding-left: 10px;
    font-size: 14px;
}

.yrE7nyb4920taxnMrvbg {
    color: rgb(var(--accent-brand)) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/reg/reg.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA,wDAAwD;;AAExD;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;AACvC;;AAEA,yDAAyD;;AAEzD,yDAAyD;;AAEzD;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,0DAA0D;;AAE1D,0DAA0D;;AAE1D;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,2DAA2D;;AAE3D,yDAAyD;;AAEzD;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,+CAA+C;IAC/C,iDAAiD;IACjD,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,0DAA0D;;AAE1D;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,oCAAoC;IACpC,UAAU;;EAEZ;;AAEF;IACI,YAAY;IACZ,qBAAqB;IACrB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,6CAA6C;IAC7C,oCAAoC;IACpC,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE;MACE,iBAAiB;IACnB;IACA;MACE,kBAAkB;MAClB,eAAe;IACjB;AACJ;;EAEE,mBAAmB;;AAErB;;EAEE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":[".Title {\n    font-size: 32px;\n    font-weight: 510;\n    line-height: 110%;\n    margin-bottom: 16px;\n    text-align: center;\n    color: rgb(var(--placeholder-primary));\n}\n\n/*--------------------zero position--------------------*/\n\n.zeroPosition {\n    margin-top: 40px;\n    display: flex;\n    flex-direction: column;\n    height: 95vh;\n    overflow-y: auto;\n}\n\n@media (max-width: 590px) {\n    .zeroPosition {\n        margin-top: 20px;\n    }\n}\n\n@media (max-width: 540px) {\n    .zeroPosition {\n        margin-top: 10px;\n    }\n}\n\n.zeroPositionInner {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    height: 100%;\n}\n\n.zeroPosition > .zeroPositionInner > img {\n    width: 170px;\n    height: 170px;\n    margin-bottom: 25px;\n}\n\n.zeroPositionBottom {\n    margin-top: auto;\n}\n\n.zeroPositionText {\n    font-size: 16px;\n    text-align: center;\n    line-height: 125%;\n    font-weight: 410;\n    margin-bottom: 20px;\n}\n\n.zeroPositionPrivacy {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.zeroPositionPrivacy > p {\n    font-size: 14px;\n    letter-spacing: -0.07px;\n}\n\n.zeroPositionPrivacy > p > span {\n    cursor: pointer;\n    text-decoration: underline;\n    transition: color 0.3s ease 0s;\n}\n\n.zeroPositionPrivacy:hover > p > span {\n    color: #007aff;\n}\n\n.checkbox {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 20px;\n    min-height: 20px;\n    max-height: 20px;\n    max-width: 20px;\n    border: 2px solid rgb(var(--accent-brand));\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.checkbox > svg {\n    position: relative;\n    z-index: 2;\n}\n\n.checkboxChecked {\n    border: none;\n    background: #007aff;\n}\n\n.createWallet {\n    margin-top: 20px;\n    width: 100%;\n    margin-bottom: 8px;\n    transition: background 0.3s ease 0s;\n}\n\n.createWallet:hover {\n    background: rgba(var(--accent-brand), 0.8);\n}\n\n.createWallet:disabled {\n    background: rgba(var(--accent-brand), 0.3);\n}\n\n.importWallet:disabled {\n    background: rgba(var(--accent-brand), 0.3);\n}\n\n.createWalletLink {\n    font-size: 17px;\n    color: #007aff;\n    background: transparent;\n}\n\n.createWalletLink:hover {\n    background: transparent;\n}\n\n.importWallet {\n    background: rgba(0, 122, 255, 0.10);\n    width: 100%;\n    color: #007aff;\n    font-size: 17px;\n    font-weight: 590;\n    padding: 14px;\n    border-radius: 12px;\n    height: auto;\n    display: block;\n    margin-bottom: 20px;\n}\n\n.importWallet:hover {\n    background: rgba(0, 122, 255, 0.20);\n}\n\n/*--------------------/zero position--------------------*/\n\n/*--------------------first position--------------------*/\n\n.firstPosition {\n    margin-top: 10px;\n}\n\n.firstPositionTitle {\n    margin-bottom: 20px;\n}\n\n.firstPositionInput {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    margin-bottom: 10px;\n}\n\n.firstPositionCount {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 20px;\n    min-width: 51px;\n    min-height: 51px;\n    max-width: 51px;\n    max-height: 51px;\n    color: rgb(var(--placeholder-tertiary));\n    background: rgb(var(--secondary-bg));\n}\n\n.firstPositionInput:not(:first-child) > div:nth-child(2) {\n    width: 100%;\n}\n\n.firstPositionBtns {\n    padding-bottom: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 5px;\n}\n\n/*--------------------/first position--------------------*/\n\n/*--------------------second position--------------------*/\n\n.secondPosition {\n    margin-top: 10px;\n    padding-bottom: 20px;\n}\n\n.secondPositionCards {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px 8px;\n}\n\n.secondPositionCard {\n    width: 100%;\n}\n\n.secondPositionCard > button {\n    width: 100%;\n    padding: 16px 12px;\n    border-radius: 16px;\n    outline: none;\n    border: none;\n    font-size: 14px;\n    color: rgb(var(--placeholder-primary));\n    background-color: rgb(var(--secondary-bg));\n    line-height: 128%;\n}\n\n.createWalletSave {\n    margin: 20px auto;\n}\n\n/*--------------------/second position--------------------*/\n\n/*--------------------third position--------------------*/\n\n.thirdPosition {\n    height: 100vh;\n    margin-top: 10px;\n}\n\n.passwordInput {\n    font-size: 18px;\n    padding: 16px;\n    border-radius: 20px;\n    width: 100%;\n    outline: none;\n    line-height: 133.33%;\n    letter-spacing: -0.24px;\n    background: rgb(var(--secondary-bg)) !important;\n    color: rgb(var(--placeholder-primary)) !important;\n    border: none;\n    margin-bottom: 10px;\n}\n\n.createWalletFull {\n    width: 100%;\n}\n\n/*--------------------/third position--------------------*/\n\n.modalTopButton {\n    color: #1c77ff;\n    font-size: 16.5px;\n    font-weight: 540;\n    letter-spacing: 0.43px;\n    padding: 0;\n    background: transparent;\n    cursor: pointer;\n    border: none;\n    transition: color 0.3s ease 0s;\n    justify-content: flex-end;\n}\n\n.modalTopButton:first-child {\n    justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n    color: #055ada;\n    background: transparent;\n}\n\n.modalTitle {\n    font-size: 32px;\n    color: rgb(var(--placeholder-primary));\n    font-weight: 760;\n    letter-spacing: 0.43px;\n    text-align: center;\n    line-height: 129.41%;\n    white-space: nowrap;\n    margin-bottom: 24px;\n}\n\n@media (max-width: 350px) {\n    .modalTitle {\n        font-size: 25px;\n    }\n}\n\n.firstPositionInput {\n    position: relative;\n}\n\n.errorInput > input {\n    border: 1px solid rgb(var(--accent-error));\n}\n\n.errorInput > div {\n    color: rgb(var(--accent-error)) !important;\n}\n\n.correct > input {\n  border: 1px solid rgba(11, 167, 11, 0.6) !important;\n}\n\n.correct > div {\n    color: rgba(11, 167, 11, 0.7) !important;\n}\n\n.tabButtonDiv {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-102%, -50%);\n    /* -102% /  2% */\n    width: calc(50% - 8px) ; \n    height: calc(100% - 2px);\n    border-radius: 12px;\n    background: rgb(var(--accent-brand));\n    z-index: 4;\n  \n  }\n\n.tabPanel {\n    padding: 2px;\n    border-radius: 8.91px;\n    background: rgb(var(--secondary-bg));\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 15px;\n    position: relative;\n  }\n  \n  .tabButton {\n    padding: 5px 15px;\n    height: auto;\n    background: transparent;\n    font-size: 14.5px;\n    line-height: 138%;\n    width: 100%;\n    cursor: pointer;\n    z-index: 5;\n  }\n  \n  .tabButton:hover {\n    background: transparent;\n  }\n  \n  .tabButtonActive {\n    border-radius: 6.93px;\n    border: 0.5px solid rgba(116, 116, 128, 0.08);\n    background: rgb(var(--accent-brand));\n    font-weight: 510;\n    transition: color 0.3s ease 0s;\n  }\n  \n  .tabButtonActive:hover {\n    color: rgba(var(--placeholder-primary), 0.1);\n  }\n  \n  @media (max-width: 350px) {\n    .tabButton {\n      padding: 5px 10px;\n    }\n    .actionButton {\n      padding: 14px 15px;\n      font-size: 17px;\n    }\n}\n\n  /* choose version */\n  \n.action,\n.actionDelete {\n  width: 100%;\n  background: transparent;\n  padding: 10px 0;\n  justify-content: flex-start;\n  font-size: 16px;\n  font-weight: 410;\n  line-height: 129%;\n}\n\n.action {\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  /* transition: all 0.3s ease 0s; */\n}\n\n/* .action:hover {\n    opacity: 0.8;\n} */\n\n.action:last-child {\n  margin-bottom: 10px;\n}\n\n.action:not(:last-child):after {\n  content: '';\n  width: 100%;\n  height: 1px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: rgba(116, 116, 128, 0.4);\n}\n\n.actionLang {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  height: 43px;\n}\n\n.customSelector {\n    position: relative;\n    margin-bottom: 24px;\n}\n\n.customSelectorInner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    width: 100%;\n    padding: 8px;\n    border-radius: 16px;\n    background: rgb(var(--secondary-bg));\n    position: relative;\n    cursor: pointer;\n    transition: background 0.3s ease 0s;\n}\n\n.customSelectorInner:hover {\n    background: rgba(var(--secondary-bg), 0.9);\n}\n\n.customSelectorInner > button {\n    max-width: 40px;\n    max-height: 40px;\n    min-width: 40px;\n    min-height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 16px;\n    border: none;\n    background: rgb(var(--tertiary-bg));\n    cursor: pointer;\n}\n\n.dropdown {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 60px;\n    z-index: 5;\n    background: rgb(var(--secondary-bg));\n    border-radius: 16px;\n    padding: 8px 14px;\n}\n\n.dropdown > div{\n    font-size: 14px !important;\n}\n\n.customSelected {\n    padding-left: 10px;\n    font-size: 14px;\n}\n\n.selectedSelect {\n    color: rgb(var(--accent-brand)) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Title": `IP51iqYlrDnM5fx907pn`,
	"zeroPosition": `yGTDNFPVT_2hZxD1SpXY`,
	"zeroPositionInner": `pssva7hlbZ7aWw0TojD1`,
	"zeroPositionBottom": `SjnGZ0BOPayOLWGniGYw`,
	"zeroPositionText": `yiwQpd4QAmwMl4nrD9HQ`,
	"zeroPositionPrivacy": `ToHlYRE4zhZ4ygk5ee_u`,
	"checkbox": `a146krIkFeVJsIBQUhNi`,
	"checkboxChecked": `KVCiDjzF0HofUQHVco1A`,
	"createWallet": `k_ZhOfZ4zU_4rSaSUhaz`,
	"importWallet": `o_6b1aFKyesaGWJA6lhI`,
	"createWalletLink": `FIge6i7RzVvPLoghYnGn`,
	"firstPosition": `uL_9usY6GJPPOb_LFW8V`,
	"firstPositionTitle": `V4v_zqCE8weyMW5gJcnf`,
	"firstPositionInput": `LRRSvRm77y_OPnVM14hK`,
	"firstPositionCount": `lXV704iirmS26rNcj5LQ`,
	"firstPositionBtns": `hZLiOXHZy4Lt956MURpC`,
	"secondPosition": `d_0M0iJ_z3Xhb6di8ENA`,
	"secondPositionCards": `UOYwq47m_TbU5ybrICz0`,
	"secondPositionCard": `P0Kd2XZHfW_QrGBhXbt_`,
	"createWalletSave": `ghqiJJET5i12K250CAzn`,
	"thirdPosition": `d5U8zFNMEAthyEjfjXzG`,
	"passwordInput": `noSXa_l11Dq4S2ywDC8j`,
	"createWalletFull": `CclL_iHPFBjJsj9q0ycT`,
	"modalTopButton": `rm58JldqLS6XIMo38XYu`,
	"modalTitle": `VQDruPYpJiIGv5KkkHQU`,
	"errorInput": `LgUDky7ZZiUuLwfUJyBL`,
	"correct": `KGHvhpclrtreSkfVyQXI`,
	"tabButtonDiv": `zqqoUqkoaE_Od4_WXkxx`,
	"tabPanel": `kseZACPkNjHSTJfhwy12`,
	"tabButton": `YwrAxcpCmZy6IFiCkfm6`,
	"tabButtonActive": `jfcQjBAaduc7C3EnPBcQ`,
	"actionButton": `LO0riiiLHiTZWbUh9aW9`,
	"action": `kZl7u4PdYU6PqWT_9l6D`,
	"actionDelete": `ULi2QXduOyITYa2yywbi`,
	"actionLang": `ig31NSKuh0yr69rwHx3w`,
	"customSelector": `yjwLtc0pMOnJmh7RQQXV`,
	"customSelectorInner": `Tn2JFwS0TZeU1G3zizwQ`,
	"dropdown": `_8VDiP0jRAUwdgPvH6E0`,
	"customSelected": `MOAOWC11f0BodImCs5gw`,
	"selectedSelect": `yrE7nyb4920taxnMrvbg`
};
export default ___CSS_LOADER_EXPORT___;
